<app-map-view
  #mapView
  *ngIf="collection"
  [visible]="visible"
  [dataSource]="collection"
  (stockDblClick)="onCellDblClicked()"
  [groupingType]="groupings"
></app-map-view>
